<template>
  <v-row>
    <v-col>
      <v-card class="pa-4">
        <v-btn :to="{ name: 'apply' }" x-large :block="$vuetify.breakpoint.smAndDown" color="primary">
          <v-icon left>mdi-credit-card-plus-outline</v-icon>
          {{ $t('辦門號')}}
        </v-btn>
        <v-btn
          :to="{ name: 'query' }"
          x-large
          :block="$vuetify.breakpoint.smAndDown"
          color="primary"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : 'ml-1'"
        >
          <v-icon left>mdi-account-search</v-icon>
          {{ $t("一般查證") }}
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && canBatch"
          x-large
          :block="$vuetify.breakpoint.smAndDown"
          color="primary"
          :to="{ name: 'batch' }"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : 'ml-1'"
        >
          <v-icon left>mdi-layers-search</v-icon>
          {{ $t("大量查證") }}
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp && canBatch && isManager"
          x-large
          :block="$vuetify.breakpoint.smAndDown"
          color="primary"
          :to="{ name: 'apply.batch' }"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : 'ml-1'"
        >
          <v-icon left>mdi-credit-card-multiple-outline</v-icon>
          {{ $t("大量辦門號") }}
        </v-btn>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          class="mt-2"
          centered
          grow
        >
          <v-tab key="query-logs" href="#query-logs">
            {{ $t("近期記錄") }}
          </v-tab>
          <v-tab key="applications" href="#applications">
            {{ $t("辦門號記錄") }}
          </v-tab>
          <v-tabs-slider></v-tabs-slider>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item key="query-logs-content" value="query-logs">
            <query-logs-table
              :isLoading="isLoading"
              :items="logs"
              :items-per-page="-1"
              >
            </query-logs-table>
          </v-tab-item>

          <v-tab-item key="applications-content" value="applications">
            <applications-table></applications-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import QueryLogsTable from '../components/QueryLogsTable';
import ApplicationsTable from '../components/ApplicationsTable';

export default {
  components: {
    QueryLogsTable,
    ApplicationsTable,
  },

  data() {
    return {
      isLoading: false,
      tab: 'query-logs',
    }
  },

  computed: {
    locale() {
      return this.$root.$i18n.locale;
    },

    ...mapState('queries', {
      logs: 'all'
    }),

    ...mapGetters(['canBatch', 'isManager']),
  },

  watch: {
    locale() {
      this.fetchUnreadNews();
    }
  },

  async mounted() {
    if (!this.logs.length) {
      this.isLoading = true;
      await this.getLogs({ limit: 20 });
      this.isLoading = false;
    }
  },

  methods: {
    ...mapActions('queries', {
      getLogs: 'get'
    }),
  }
}
</script>
